import { render, staticRenderFns } from "./assistenteConfiguracao.vue?vue&type=template&id=f6f9bfb4&scoped=true&"
import script from "./assistenteConfiguracao.vue?vue&type=script&lang=js&"
export * from "./assistenteConfiguracao.vue?vue&type=script&lang=js&"
import style0 from "./assistenteConfiguracao.vue?vue&type=style&index=0&id=f6f9bfb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f9bfb4",
  null
  
)

export default component.exports